<app-header-gc></app-header-gc>

<ion-content class="page-gc" [fullscreen]="false">

  <ion-fab vertical="top" horizontal="end" slot="fixed">
    <ion-fab-button routerLink="/modulo-gc/gc-funcoes">
      <ion-icon name="arrow-back-outline"></ion-icon>
    </ion-fab-button>

    <ion-fab-button
      style="margin-top: 5px;"
      [routerLink]="['/modulo-gc/gc-cadastrar-arquivo-repositorio']"
      *ngIf="canCreateEdit"
    >
      <ion-icon name="add-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <!-- Título -->
  <div class="global-gc-title">
    <div class="title">
      REPOSITÓRIO DE ARQUIVOS
    </div>
  </div>

  <!-- FILTRO -->
  <div class="global-filter-area-v2">

    <div class="filter-area-header">
      <div>
        <div class="filter-area-title">
          Filtros
        </div>

        <div class="filter-area-subtitle">
          Refine sua busca
        </div>
      </div>
    </div>

    <div class="filter-area-body repository-filter-body">

      <ion-item class="filter-input">
        <ion-label position="floating">
          Filtro
        </ion-label>

        <ion-input
          [(ngModel)]="filtro"
          placeholder="Nome ou descrição"
          (keyup.enter)="findByFilter()"
        ></ion-input>
      </ion-item>

    </div>

    <div class="filter-actions">

      <ion-button
        fill="outline"
        color="light"
        (click)="limparFiltros()"
        [disabled]="carregando"
      >
        <ion-icon
          slot="start"
          name="refresh-outline"
        ></ion-icon>

        Limpar
      </ion-button>

      <ion-button
        (click)="findByFilter()"
        [disabled]="carregando"
      >
        <ion-spinner
          *ngIf="carregando"
          slot="start"
          name="crescent"
        ></ion-spinner>

        <ion-icon
          *ngIf="!carregando"
          slot="start"
          name="search-outline"
        ></ion-icon>

        Consultar
      </ion-button>

    </div>

  </div>

  <!-- Contexto da listagem -->
  <div
    class="gc-list-context"
    *ngIf="mensagem"
  >

    <div class="left">
      <ion-icon name="folder-open-outline"></ion-icon>

      <div>
        {{mensagem}}
      </div>
    </div>

    <div
      class="sort-container"
      *ngIf="arquivos.length >= 1"
    >

      <div class="sort-box">
        <div class="sort-label">
          Ordenar por
        </div>

        <ion-select
          [(ngModel)]="sortBy"
          interface="popover"
          (ionChange)="ordenarArquivos()"
        >
          <ion-select-option value="nome">
            Nome
          </ion-select-option>

          <ion-select-option value="id">
            Data de criação
          </ion-select-option>
        </ion-select>
      </div>

      <div class="sort-box">
        <div class="sort-label">
          Direção
        </div>

        <ion-select
          [(ngModel)]="sort"
          interface="popover"
          (ionChange)="ordenarArquivos()"
        >
          <ion-select-option value="ASC">
            Crescente
          </ion-select-option>

          <ion-select-option value="DESC">
            Decrescente
          </ion-select-option>
        </ion-select>
      </div>

    </div>

  </div>

  <!-- Lista -->
  <ion-card
    *ngFor="let arquivo of arquivos"
    [attr.id]="'card-' + arquivo.id"
    class="gc-list-card gc-arquivo-card"
  >

    <ion-card-header class="gc-list-card-header">

      <ion-item
        class="gc-list-meta"
        lines="none"
      >

        <ion-label class="meta-left">
          Arquivo #{{arquivo.id}}
        </ion-label>

        <div
          class="meta-right"
          slot="end"
        >

          <ion-label
            class="gc-status-badge"
            [ngClass]="getFileTypeClass(arquivo.nome)"
          >
            {{getFileTypeLabel(arquivo.nome)}}
          </ion-label>

        </div>

      </ion-item>

      <ion-card-title class="gc-list-title">
        {{arquivo.nome}}
      </ion-card-title>

      <ion-card-subtitle class="gc-list-subtitle">
        {{formatFileSize(arquivo.kiloBytes)}}
      </ion-card-subtitle>

    </ion-card-header>

    <ion-card-content class="gc-list-body">

      <div class="arquivo-content">

        <!-- Identificação do tipo -->
        <div
          class="arquivo-type-box"
          [ngClass]="getFileTypeClass(arquivo.nome)"
        >

          <ion-icon
            [name]="getFileTypeIcon(arquivo.nome)"
          ></ion-icon>

          <span>
            {{getFileTypeLabel(arquivo.nome)}}
          </span>

        </div>

        <!-- Informações -->
        <div class="arquivo-info">

          <div class="arquivo-info-line">
            <ion-icon name="server-outline"></ion-icon>

            <div>
              <strong>Tamanho</strong>

              <span>
                {{formatFileSize(arquivo.kiloBytes)}}
              </span>
            </div>
          </div>

          <div class="arquivo-info-line arquivo-url-line">
            <ion-icon name="link-outline"></ion-icon>

            <div>
              <strong>URL pública</strong>

              <button
                type="button"
                class="arquivo-url"
                [title]="getFilePublicURL(arquivo.path, arquivo.nome)"
                (click)="viewPublicFile(arquivo)"
              >
                {{getFilePublicURL(arquivo.path, arquivo.nome)}}
              </button>
            </div>
          </div>

        </div>

      </div>

      <!-- Ações -->
      <div class="global-card-buttons">

        <ion-button
          color="tertiary"
          (click)="copyToClipboard(
            getFilePublicURL(
              arquivo.path,
              arquivo.nome
            )
          )"
        >
          <ion-icon name="copy-outline"></ion-icon>
          &nbsp;Copiar URL
        </ion-button>

        <ion-button
          color="dark"
          (click)="view(arquivo)"
          [disabled]="arquivoEmVisualizacaoId === arquivo.id"
        >

          <ion-spinner
            *ngIf="arquivoEmVisualizacaoId === arquivo.id"
            name="crescent"
          ></ion-spinner>

          <ion-icon
            *ngIf="arquivoEmVisualizacaoId !== arquivo.id"
            name="eye-outline"
          ></ion-icon>

          &nbsp;

          {{
            arquivoEmVisualizacaoId === arquivo.id
              ? 'Carregando'
              : 'Visualizar'
          }}

        </ion-button>

        <ion-button
          color="medium"
          [routerLink]="[
            '/modulo-gc/gc-cadastrar-arquivo/' + arquivo.id
          ]"
          *ngIf="canCreateEdit"
        >
          <ion-icon name="create-outline"></ion-icon>
          &nbsp;Editar
        </ion-button>

        <ion-button
          color="danger"
          (click)="delete(arquivo)"
          *ngIf="canRemove"
        >
          <ion-icon name="trash-outline"></ion-icon>
          &nbsp;Excluir
        </ion-button>

      </div>

      <!-- Auditoria -->
      <div class="global-card-audit">

        <div class="global-card-audit-item">
          <ion-icon name="person-add-outline"></ion-icon>

          <span>
            Criado em
            {{arquivo.dataGravacao | date: "dd/MM/yyyy HH:mm:ss"}}

            <ng-container *ngIf="arquivo.nomeCriador">
              por {{arquivo.nomeCriador}}
            </ng-container>
          </span>
        </div>

        <div class="global-card-audit-item">
          <ion-icon name="create-outline"></ion-icon>

          <span>
            Última alteração em
            {{
              arquivo.dataUltimaAtualizacao
                | date: "dd/MM/yyyy HH:mm:ss"
            }}

            <ng-container *ngIf="arquivo.nomeUltimoAtualizador">
              por {{arquivo.nomeUltimoAtualizador}}
            </ng-container>
          </span>
        </div>

      </div>

    </ion-card-content>

  </ion-card>

  <!-- Paginação -->
  <ion-infinite-scroll
    (ionInfinite)="carregarArquivos($event)"
    threshold="100px"
    [disabled]="page >= totalPages"
  >
    <ion-infinite-scroll-content
      loadingSpinner="bubbles"
      loadingText="Carregando..."
    ></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <!-- VISUALIZAÇÃO -->
  <ion-modal
    [isOpen]="modalVisualizacaoAberto"
    [backdropDismiss]="false"
    cssClass="modal-visualizacao-arquivo"
    (didDismiss)="onModalVisualizacaoDidDismiss()"
    (keydown.escape)="fecharModalVisualizacao()"
  >

    <ng-template>

      <ion-header>
        <ion-toolbar>

          <ion-title>
            {{arquivoVisualizacao?.nome}}
          </ion-title>

          <ion-button
            slot="end"
            fill="clear"
            class="modal-close-button"
            aria-label="Fechar"
            (click)="fecharModalVisualizacao()"
          >
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>

        </ion-toolbar>
      </ion-header>

      <ion-content
        class="page-gc modal-content"
        [fullscreen]="false"
      >

        <div
          class="modal-shell viewer-modal-shell"
          *ngIf="arquivoVisualizacao"
        >

          <!-- Imagem -->
          <div
            class="viewer-area image-preview"
            *ngIf="isImage(arquivoVisualizacao.nome)"
          >
            <img
              [src]="arquivoVisualizacao.safePath"
              [alt]="arquivoVisualizacao.nome"
            />
          </div>

          <!-- PDF -->
          <iframe
            *ngIf="isPDF(arquivoVisualizacao.nome)"
            [src]="arquivoVisualizacao.safePath"
            class="document-preview"
            title="Visualização do PDF"
          ></iframe>

          <!-- Office -->
          <iframe
            *ngIf="
              isOfficeFile(arquivoVisualizacao.nome) &&
              arquivoVisualizacao.safePath
            "
            [src]="arquivoVisualizacao.safePath"
            class="document-preview"
            title="Visualização do documento"
          ></iframe>

          <!-- Tipo sem preview -->
          <div
            class="viewer-area unknown-preview"
            *ngIf="isUnknownFile(arquivoVisualizacao.nome)"
          >

            <ion-icon
              [name]="getFileTypeIcon(arquivoVisualizacao.nome)"
            ></ion-icon>

            <div class="unknown-preview-title">
              Visualização não disponível
            </div>

            <div class="unknown-preview-description">
              Este tipo de arquivo não possui visualização integrada.
              Você pode abri-lo diretamente em uma nova janela.
            </div>

          </div>

          <div class="viewer-actions">

            <ion-button
              fill="outline"
              color="medium"
              (click)="copyToClipboard(
                getFilePublicURL(
                  arquivoVisualizacao.path,
                  arquivoVisualizacao.nome
                )
              )"
            >
              <ion-icon
                slot="start"
                name="copy-outline"
              ></ion-icon>

              Copiar URL
            </ion-button>

            <ion-button
              color="dark"
              (click)="viewPublicFile(arquivoVisualizacao)"
            >
              <ion-icon
                slot="start"
                name="open-outline"
              ></ion-icon>

              Abrir em nova janela
            </ion-button>

          </div>

        </div>

      </ion-content>

    </ng-template>

  </ion-modal>

</ion-content>